import { BareActionContext } from 'vuex-typex'
import { AuthState } from '../state'
import { RootState } from '@/store/'
import authStore from '../auth-store'
import authUtils from './auth-utils'

export default async function authCallback(context: BareActionContext<AuthState, RootState>): Promise<{ page: string, id: string|null|undefined, uid: string|null|undefined } | null> {
  const state: { page: string, id: string|null|undefined, uid: string|null|undefined } = authUtils.authService.restoreState();
  return new Promise<{ page: string, id: string|null|undefined, uid: string|null|undefined } | null>((resolve, reject) => {
    if (authStore.isAuthenticated) {
      return resolve(state)
    } else {
      authUtils.authService.handleAuthCallback().then((success: boolean) => {
        if (success) {
          return resolve(state)
        } else {
          return resolve(null)
        }
      })
    }
  })
}
